
define('app/dashboard/leagues/instances/views/fantTeamView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/models/leagueUserModel',
	'known/models/fantasyTeamModel',
	'known/models/productTypeModel',
	'app/dashboard/leagues/instances/views/fantTeamSettingsView',
	'app/dashboard/leagues/instances/views/fantTeamDelView',
	
	//Templates
	'text!app/dashboard/leagues/instances/templates/lgInstTeamTemplate.html'
], function(
		$, 
		_, 
		Backbone, 
		UserModel, 
		LeagueInstanceModel,
		LeagueUserModel,
		FantasyTeamModel,
		ProductTypeModel,
		FantTeamSettingsView,
		FantTeamDelView,
		teamHtml){
	
	var FantTeamView = Backbone.View.extend({
		initialize: function(options) {
			this.userModel = options.userModel; 
			this.lgInstance = options.lgInstance;
			this.fantTeam = options.fantTeam;
			this.prodType = options.prodType;
			
			this.teamTemplate = _.template(teamHtml.trim());
			
			this.buildEl();
			
			this.settingsView = new FantTeamSettingsView({
				el: $(this.el),
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				fantTeam: this.fantTeam,
				prodType: this.prodType});
			
			this.deleteView = new FantTeamDelView({
				el: $(this.el),
				userModel: this.userModel, 
				lgInstance: this.lgInstance,
				fantTeam: this.fantTeam,
				prodType: this.prodType});
			
			this.listenTo(this.fantTeam, 'change', this.updateVisuals);
			this.listenTo(this.lgInstance, 'change:draftType', this.updateBudgetDisplay);
		},
		
		render: function () {
			this.settingsView.render();
			this.deleteView.render();
			
			return this;
		},
		
		buildEl: function() {
			this.setElement($(this.teamTemplate({
				teamPosNameText: this.teamText(),
				teamOwnerName: this.lgInstance.get("leagueUsers").get(this.fantTeam.get('leagueUserId')).prettyDispName(),
				teamBudget: '$' + this.fantTeam.get('auctionBudget')})));
			this.updateBudgetDisplay();
		},
		
		updateVisuals: function() {
			$(this.el).find('.teamPosNameText').html(this.teamText());
			$(this.el).find('.teamOwnerText').html(this.lgInstance.get("leagueUsers").get(this.fantTeam.get('leagueUserId')).prettyDispName());
			$(this.el).find('.teamBudgetText').html('$' + this.fantTeam.get('auctionBudget'));
			
		},
		
		updateBudgetDisplay: function() {
			if(this.lgInstance.get('draftType') == 'AUCTION'){
				$(this.el).find('.fantTeamBudgetInfo').show();
			} else {
				$(this.el).find('.fantTeamBudgetInfo').hide();
			}
		},
		
		teamText: function() {
			return '(' + this.fantTeam.get('draftPosition') + ') ' + this.fantTeam.get('teamName'); 
		},
	    
	    destroyView: function() {
	    	this.settingsView.destroyView();
	    	this.deleteView.destroyView();
	    	
	    	this.stopListening();
	    	this.undelegateEvents();
	    	
	    	//Remove DOM
	    	$(this.el).removeData().unbind();
	    	this.remove();  
	    	Backbone.View.prototype.remove.call(this);
        }
	});
	
	return FantTeamView;  
});